import React from 'react';

const Footer = () => (
  <div className="mt-24">
    <p className="dark:text-gray-200 text-gray-700 text-center m-20">
      © 2022 All rights reserved by TheStudentProjectGroup
    </p>
  </div>
);

export default Footer;
